import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComunicacionService {

  @Output() loading: EventEmitter<boolean> = new EventEmitter();
  @Output() loadingTransp: EventEmitter<boolean> = new EventEmitter();
  
  constructor() { }

  
}
